import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const EnterSerialNumberText = styled.div`
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #040222;
    margin-top: 20px;
`;

export const SerialNumberText = styled.div`
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #040222;
    margin-top: 20px;
`;

export const InputWrapper = styled.div`
    display: flex;
    margin-top: 20px;
    flex-direction: column;
`;

export const EnterMoreDetails = styled.div`
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #040222;
`;

export const ButtonWrapper = styled.div`
    margin: 25px 0;
`;

export const InputAndScanWrapper = styled.div`
    display: flex;
    gap: 12px;
    align-items: flex-end;
    width: 100%;
`;

export const InputContainer = styled.div`
    flex: 1;
`;

export const ScanButton = styled.button`
    padding: 12px 16px;
    background-color: #40a7a3;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: background-color 0.2s ease;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover:not(:disabled) {
        background-color: #358a87;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;
